import Groups from '../tables/Groups';
import Posts from '../tables/Posts';
import PostsToTags from '../tables/PostsToTags';
import Profiles from '../tables/Profiles';
import ProfilesToGroups from '../tables/ProfilesToGroups';
import Tags from '../tables/Tags';
var groups = new Groups();
var posts = new Posts();
var postsToTags = new PostsToTags();
var profiles = new Profiles();
var profilesToGroups = new ProfilesToGroups();
var tags = new Tags();
var TagPerformance = {
    alias: 'Tag Performance',
    tables: [
        {
            id: groups.id,
            alias: groups.id,
        },
        {
            id: profiles.id,
            alias: profiles.id,
        },
        {
            id: posts.id,
            alias: posts.id,
        },
        {
            id: profilesToGroups.id,
            alias: profilesToGroups.id,
        },
        {
            id: postsToTags.id,
            alias: postsToTags.id,
        },
        {
            id: tags.id,
            alias: tags.id,
        },
    ],
    joins: [
        {
            left: {
                tableAlias: groups.id,
                columnId: 'group_id',
            },
            right: {
                tableAlias: profilesToGroups.id,
                columnId: 'group_id',
            },
            joinType: 'inner',
        },
        {
            left: {
                tableAlias: profilesToGroups.id,
                columnId: 'customer_profile_id',
            },
            right: {
                tableAlias: profiles.id,
                columnId: 'customer_profile_id',
            },
            joinType: 'inner',
        },
        {
            left: {
                tableAlias: profiles.id,
                columnId: 'customer_profile_id',
            },
            right: {
                tableAlias: posts.id,
                columnId: 'customer_profile_id',
            },
            joinType: 'inner',
        },
        {
            left: {
                tableAlias: posts.id,
                columnId: 'guid',
            },
            right: {
                tableAlias: postsToTags.id,
                columnId: 'guid',
            },
            joinType: 'left',
        },
        {
            left: {
                tableAlias: postsToTags.id,
                columnId: 'tag_id',
            },
            right: {
                tableAlias: tags.id,
                columnId: 'tag_id',
            },
            joinType: 'left',
        },
    ],
};
export default TagPerformance;
